// extracted by mini-css-extract-plugin
export default {"FifthContent":"FifthContent_FifthContent__ytysL","desText":"FifthContent_desText__EbV4-","accordion":"FifthContent_accordion__o1Rr9"};